enum ViewModes {
  Gantt = 'gantt',
  List = 'list',
  Map = 'map',
  Calendar = 'calendar',
}

export default ViewModes
